import { createWebHistory, createRouter } from "vue-router";
import Studies from "../views/Studies.vue";

const routes = [{
    path: "/studies",
    name: "Studies",
    component: Studies
}, ];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;